import { Directive, HostListener, Input } from "@angular/core";
import { Router } from "@angular/router";

@Directive({
  selector: "[appOpenInNewTab]",
  standalone: true,
})
export class OpenInNewTabDirective {
  @Input("appOpenInNewTab") route!: string;

  constructor(private router: Router) {}

  @HostListener("pointerdown", ["$event"])
  onPointerDown(event: PointerEvent) {
    if (event.button === 0 && (event.ctrlKey || event.metaKey)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      this.openInNewTab();
    }
  }

  @HostListener("click", ["$event"])
  onClick(event: MouseEvent) {
    if (event.ctrlKey || event.metaKey) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    if (this.route) {
      this.router.navigateByUrl(this.route);
    }
  }

  @HostListener("auxclick", ["$event"])
  onAuxClick(event: MouseEvent) {
    if (event.button === 1) {
      event.preventDefault();
      event.stopPropagation();
      this.openInNewTab();
    }
  }

  private openInNewTab(): void {
    const urlTree = this.router.createUrlTree([this.route]);
    const serializedUrl = this.router.serializeUrl(urlTree);
    const newWindow = window.open(serializedUrl, "_blank");
    if (newWindow) {
      newWindow.blur();
    }
    window.focus();
  }
}

@Directive({
  selector: "[appOpenInNewTabAction]",
  standalone: true,
})
export class OpenInNewTabActionDirective {
  @Input("appOpenInNewTabAction") actionFn!: () => string | undefined;

  constructor(private router: Router) {}

  @HostListener("pointerdown", ["$event"])
  onPointerDown(event: PointerEvent) {
    if (event.button === 0 && (event.ctrlKey || event.metaKey)) {
      const ruta = this.actionFn?.();
      if (!ruta) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      this.openInNewTab(ruta);
    }
  }

  @HostListener("click", ["$event"])
  onClick(event: MouseEvent) {
    const ruta = this.actionFn?.();
    if (!ruta) return;

    if (event.ctrlKey || event.metaKey) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    if (event.button === 1) {
      event.preventDefault();
      event.stopImmediatePropagation();
      this.openInNewTab(ruta);
    } else {
      this.router.navigateByUrl(ruta);
    }
  }

  @HostListener("auxclick", ["$event"])
  onAuxClick(event: MouseEvent) {
    if (event.button === 1) {
      event.stopPropagation();
      this.onClick(event);
    }
  }

  private openInNewTab(ruta: string): void {
    const urlTree = this.router.createUrlTree([ruta]);
    const serializedUrl = this.router.serializeUrl(urlTree);
    const newWindow = window.open(serializedUrl, "_blank");
    if (newWindow) {
      newWindow.blur();
    }
    window.focus();
  }
}
